var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/Users/nam.phamanh/Documents/Nam/git/cs/lazada/node_modules/_nunjucks-loader@2.4.9@nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/app/module/firstmessage/tpl.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div id=\"alime-first-message\">\n  ";
if(runtime.contextOrFrameLookup(context, frame, "banner")) {
output += "\n  <div class=\"alime-top-banner _block J_Bannerlist\">\n    <div class=\"alime-top-banner _scroller J_Scroller\">\n      ";
frame = frame.push();
var t_3 = runtime.contextOrFrameLookup(context, frame, "banner");
if(t_3) {var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("item", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n      <div class=\"alime-top-banner _item-wrapper J_Banner J_Blank\" href=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"link"), env.opts.autoescape);
output += "\" data-bid=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"id"), env.opts.autoescape);
output += "\">\n        <div class=\"alime-top-banner _item\">\n          <img class=\"alime-top-banner _image J_DisableZoomIn lib-img\" src=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"cover"), env.opts.autoescape);
output += "\" alt=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"title"), env.opts.autoescape);
output += "\">\n        </div>\n      </div>\n      ";
;
}
}
frame = frame.pop();
output += "\n    </div>\n    <div class=\"alime-top-banner _indicator J_Indicator\">\n      <div class=\"alime-top-banner _dot\"></div>\n    </div>\n  </div>\n  ";
;
}
output += "\n\n  <div class=\"alime-robot _block\">\n    <div class=\"m-chatpanel-firstmessage\">\n      <div class=\"alime-text _block -top\">";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.contextOrFrameLookup(context, frame, "welcomeTopMessage")), env.opts.autoescape);
output += "</div>\n\n      <ul class=\"list alime-list _parent\" role=\"tree\">\n        ";
frame = frame.push();
var t_7 = runtime.contextOrFrameLookup(context, frame, "list");
if(t_7) {var t_6 = t_7.length;
for(var t_5=0; t_5 < t_7.length; t_5++) {
var t_8 = t_7[t_5];
frame.set("item", t_8);
frame.set("loop.index", t_5 + 1);
frame.set("loop.index0", t_5);
frame.set("loop.revindex", t_6 - t_5);
frame.set("loop.revindex0", t_6 - t_5 - 1);
frame.set("loop.first", t_5 === 0);
frame.set("loop.last", t_5 === t_6 - 1);
frame.set("loop.length", t_6);
output += "\n          ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index") < 4) {
output += "\n            ";
if(runtime.memberLookup((t_8),"subContent") && runtime.memberLookup((runtime.memberLookup((t_8),"subContent")),"length") > 0) {
output += "\n              <li class=\"li alime-list _item\" role=\"treeitem\">\n                <div class=\"alime-list _link -dropdown J_Category\">\n                  <span class=\"alime-list _text\">";
output += runtime.suppressValue(runtime.memberLookup((t_8),"title"), env.opts.autoescape);
output += "</span>\n                </div>\n                <ul class=\"alime-list _children -sub\" role=\"group\">\n                  ";
frame = frame.push();
var t_11 = runtime.memberLookup((t_8),"subContent");
if(t_11) {var t_10 = t_11.length;
for(var t_9=0; t_9 < t_11.length; t_9++) {
var t_12 = t_11[t_9];
frame.set("q", t_12);
frame.set("loop.index", t_9 + 1);
frame.set("loop.index0", t_9);
frame.set("loop.revindex", t_10 - t_9);
frame.set("loop.revindex0", t_10 - t_9 - 1);
frame.set("loop.first", t_9 === 0);
frame.set("loop.last", t_9 === t_10 - 1);
frame.set("loop.length", t_10);
output += "\n                  <li class=\"alime-list _item sub-list-item\" role=\"treeitem\">\n                    ";
if(runtime.memberLookup((t_12),"type") == "link") {
output += "\n                    <a href=\"";
output += runtime.suppressValue(runtime.memberLookup((t_12),"content"), env.opts.autoescape);
output += "\" class=\"alime-list _link J_Blank\" data-text=\"";
output += runtime.suppressValue(runtime.memberLookup((t_12),"content"), env.opts.autoescape);
output += "\">\n                      <span class=\"alime-list _text\">";
output += runtime.suppressValue(runtime.memberLookup((t_12),"title"), env.opts.autoescape);
output += "</span>\n                    </a>\n                    ";
;
}
else {
output += "\n                    <div class=\"alime-list _link J_SendText\" data-text=\"";
output += runtime.suppressValue(runtime.memberLookup((t_12),"content"), env.opts.autoescape);
output += "\">\n                      <span class=\"alime-list _text\">";
output += runtime.suppressValue(runtime.memberLookup((t_12),"title"), env.opts.autoescape);
output += "</span>\n                    </div>\n                    ";
;
}
output += "\n                  </li>\n                  ";
;
}
}
frame = frame.pop();
output += "\n                </ul>\n              </li>\n            ";
;
}
else {
if(runtime.memberLookup((t_8),"type") == "link") {
output += "\n              <li class=\"alime-list _item li\" role=\"treeitem\">\n                <a href=\"";
output += runtime.suppressValue(runtime.memberLookup((t_8),"content"), env.opts.autoescape);
output += "\" data-aid=\"";
output += runtime.suppressValue(runtime.memberLookup((t_8),"id"), env.opts.autoescape);
output += "\" class=\"alime-list _link J_Blank\">\n                  <span class=\"alime-list _text\">";
output += runtime.suppressValue(runtime.memberLookup((t_8),"title"), env.opts.autoescape);
output += "</span>\n                </a>\n              </li>\n            ";
;
}
else {
output += "\n              <li class=\"alime-list _item li\" role=\"treeitem\">\n                <a data-aid=\"";
output += runtime.suppressValue(runtime.memberLookup((t_8),"id"), env.opts.autoescape);
output += "\" data-text=\"";
output += runtime.suppressValue(runtime.memberLookup((t_8),"content"), env.opts.autoescape);
output += "\" class=\"alime-list _link J_SendText\">\n                  <span class=\"alime-list _text\">";
output += runtime.suppressValue(runtime.memberLookup((t_8),"title"), env.opts.autoescape);
output += "</span>\n                </a>\n              </li>\n            ";
;
}
;
}
output += "\n          ";
;
}
output += "\n        ";
;
}
}
frame = frame.pop();
output += "\n      </ul>\n      <div id=\"alimeTextBottom\" class=\"alime-text _block -bottom\">";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.contextOrFrameLookup(context, frame, "welcomeBottomMessage")), env.opts.autoescape);
output += "</div>\n    </div>\n  </div>\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/app/module/firstmessage/tpl.html"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./src/app/module/firstmessage/tpl.html
// module id = 233
// module chunks = 0 1